var React = require('react');

function AllBoldInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fbfd89;}.cls-2{fill:none;}")),React.createElement("path",{"className":"cls-1","d":"M17.93,7.71A10.26,10.26,0,1,0,28.19,18,10.27,10.27,0,0,0,17.93,7.71Zm0,18.15A7.89,7.89,0,1,1,25.82,18,7.9,7.9,0,0,1,17.93,25.86Z","key":1}),React.createElement("polygon",{"className":"cls-1","points":"17 18.83 14.63 16.46 12.95 18.14 17 22.19 22.91 16.28 21.23 14.6 17 18.83","key":2}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":3})]);
}

AllBoldInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = AllBoldInline;

AllBoldInline.default = AllBoldInline;
